import { z } from 'zod';
export const RateKindSchema = z.enum(['HORA', 'ACTO', 'IGUALA_MENSUAL', 'HITO']);
export const RateKindLabel = {
    HORA: 'Por hora',
    ACTO: 'Por acto',
    IGUALA_MENSUAL: 'Iguala mensual',
    HITO: 'Por hito',
};
export const RateKindShort = {
    HORA: '€/h',
    ACTO: '€/acto',
    IGUALA_MENSUAL: '€/mes',
    HITO: '€/hito',
};
// Reusamos el LegalArea declarado en cases.ts.
import { LegalAreaSchema } from './cases';
export const RateDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    kind: RateKindSchema,
    amountCents: z.number().int(),
    /** IVA como fracción (0.21 = 21%). */
    vatRate: z.number(),
    area: LegalAreaSchema.nullable(),
    description: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const RateListResponseSchema = z.object({
    items: z.array(RateDtoSchema),
});
export const CreateRateInputSchema = z.object({
    name: z.string().min(1, 'Nombre obligatorio').max(120),
    kind: RateKindSchema,
    amountCents: z.number().int().min(0, 'No puede ser negativo'),
    vatRate: z.number().min(0).max(1, 'IVA en fracción (0–1)'),
    area: LegalAreaSchema.nullable().optional(),
    description: z.string().max(1000).nullable().optional(),
    isActive: z.boolean().optional(),
});
export const UpdateRateInputSchema = CreateRateInputSchema.partial();
// ===== Asignaciones cliente → tarifa =====
export const ClientRateDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    rateId: z.string(),
    /** Si null, se usa Rate.amountCents al insertar línea. */
    overrideAmountCents: z.number().int().nullable(),
    notes: z.string().nullable(),
    rate: RateDtoSchema,
});
export const ClientRateListResponseSchema = z.object({
    items: z.array(ClientRateDtoSchema),
});
export const CreateClientRateInputSchema = z.object({
    rateId: z.string().min(1),
    overrideAmountCents: z.number().int().min(0).nullable().optional(),
    notes: z.string().max(500).nullable().optional(),
});
export const UpdateClientRateInputSchema = z.object({
    overrideAmountCents: z.number().int().min(0).nullable().optional(),
    notes: z.string().max(500).nullable().optional(),
});
// ===== Picker: tarifas aplicables a un cliente/área =====
// Devuelve catálogo + las asignadas marcadas + applied amount (override o base).
export const RatePickerItemSchema = z.object({
    rateId: z.string(),
    name: z.string(),
    kind: RateKindSchema,
    area: LegalAreaSchema.nullable(),
    baseAmountCents: z.number().int(),
    /** Importe que se aplicará (override del cliente si existe; si no, base). */
    appliedAmountCents: z.number().int(),
    vatRate: z.number(),
    description: z.string().nullable(),
    /** True si proviene de una asignación ClientRate del cliente solicitado. */
    isAssignedToClient: z.boolean(),
});
export const RatePickerResponseSchema = z.object({
    items: z.array(RatePickerItemSchema),
});
//# sourceMappingURL=rates.js.map